import apiClient from './client'
import type {
  Event,
  EventParticipant,
  AthleteEvent,
  CreateEventRequest,
  UpdateEventRequest,
  AddParticipantRequest,
  UpdateParticipantRequest,
  BulkAddParticipantsRequest,
  BulkAddParticipantsResponse,
} from '@shared/types/event'

export const eventsApi = {
  // === Events CRUD ===

  // POST /api/v1/assistants/{assistantId}/events
  create: async (assistantId: string, data: CreateEventRequest): Promise<Event> => {
    const response = await apiClient.post<Event>(`/assistants/${assistantId}/events`, data)
    return response.data
  },

  // GET /api/v1/assistants/{assistantId}/events
  getByAssistantId: async (assistantId: string): Promise<Event[]> => {
    const response = await apiClient.get<Event[]>(`/assistants/${assistantId}/events`)
    return response.data
  },

  // GET /api/v1/assistants/{assistantId}/events/upcoming
  getUpcoming: async (assistantId: string): Promise<Event[]> => {
    const response = await apiClient.get<Event[]>(`/assistants/${assistantId}/events/upcoming`)
    return response.data
  },

  // GET /api/v1/events/{eventId}
  getById: async (eventId: string): Promise<Event> => {
    const response = await apiClient.get<Event>(`/events/${eventId}`)
    return response.data
  },

  // PUT /api/v1/events/{eventId}
  update: async (eventId: string, data: UpdateEventRequest): Promise<Event> => {
    const response = await apiClient.put<Event>(`/events/${eventId}`, data)
    return response.data
  },

  // DELETE /api/v1/events/{eventId}
  delete: async (eventId: string): Promise<void> => {
    await apiClient.delete(`/events/${eventId}`)
  },

  // === Participants ===

  // POST /api/v1/events/{eventId}/participants
  addParticipant: async (eventId: string, data: AddParticipantRequest): Promise<EventParticipant> => {
    const response = await apiClient.post<EventParticipant>(`/events/${eventId}/participants`, data)
    return response.data
  },

  // POST /api/v1/events/{eventId}/participants/bulk
  bulkAddParticipants: async (eventId: string, data: BulkAddParticipantsRequest): Promise<BulkAddParticipantsResponse> => {
    const response = await apiClient.post<BulkAddParticipantsResponse>(`/events/${eventId}/participants/bulk`, data)
    return response.data
  },

  // GET /api/v1/events/{eventId}/participants
  getParticipants: async (eventId: string): Promise<EventParticipant[]> => {
    const response = await apiClient.get<EventParticipant[]>(`/events/${eventId}/participants`)
    return response.data
  },

  // PATCH /api/v1/events/{eventId}/participants/{athleteId}
  updateParticipant: async (eventId: string, athleteId: string, data: UpdateParticipantRequest): Promise<void> => {
    await apiClient.patch(`/events/${eventId}/participants/${athleteId}`, data)
  },

  // DELETE /api/v1/events/{eventId}/participants/{athleteId}
  removeParticipant: async (eventId: string, athleteId: string): Promise<void> => {
    await apiClient.delete(`/events/${eventId}/participants/${athleteId}`)
  },

  // === Athlete events ===

  // GET /api/v1/athletes/{athleteId}/events
  getAthleteEvents: async (athleteId: string): Promise<AthleteEvent[]> => {
    const response = await apiClient.get<AthleteEvent[]>(`/athletes/${athleteId}/events`)
    return response.data
  },
}
